import Section from '../../Section'

const AboutQuantstamp = () => (
  <Section title="About Quantstamp">
    <div>
      <p>
        Quantstamp is a global leader in blockchain security. Founded in 2017, Quantstamp’s mission
        is to securely onboard the next billion users to Web3 through its best-in-class Web3
        security products and services.
      </p>
      <p>
        Quantstamp’s team consists of cybersecurity experts hailing from globally recognized
        organizations including Microsoft, AWS, BMW, Meta, and the Ethereum Foundation. Quantstamp
        engineers hold PhDs or advanced computer science degrees, with decades of combined
        experience in formal verification, static analysis, blockchain audits, penetration testing,
        and original leading-edge research.
      </p>
      <p>
        To date, Quantstamp has performed more than 1300 audits and secured over $500 billion in
        digital asset risk from hackers. Quantstamp has worked with a diverse range of customers,
        including startups, category leaders and financial institutions. Brands that Quantstamp has
        worked with include Ethereum 2.0, Binance, Visa, PayPal, Solana, Canton, Polymarket,
        PandcakeSwap, Virtuals Protocol, Wayfinder, Lido, TrustWallet, Alchemy, World Economic
        Forum.
      </p>
      <p>
        Quantstamp’s collaborations and partnerships showcase our commitment to world-class
        research, development and security. We&apos;re honored to work with some of the top names in
        the industry and proud to secure the future of web3.
      </p>
      <p>Notable Collaborations &amp; Customers:</p>
      <ul>
        <li>
          Blockchains: Ethereum 2.0, Solana, Polygon, TON, Cardano, Binance Smart Chain, Avalanche,
          Arbitrum, Flow
        </li>
        <li>DeFi: Lido, Ethena, Compound, Curve, Venus, PancakeSwap, Polymarket</li>
        <li>
          Infra/Staking: TrustWallet, Alchemy, Liquid Collective, Kiln, Galxe, API3, ssv.network,
          Luganodes
        </li>
        <li>
          Immersive: Virtuals Protocol, Wayfinder, OpenSea, Square Enix, Parallel, Camp,
          Decentraland
        </li>
        <li>
          Institutional: Visa, Circle, Revolut, Anthropic, OpenAI, Canton, Republic, Arkham, Sequoia
        </li>
      </ul>
    </div>
    <div>
      <h4>Timeliness of content</h4>
      <p>
        The content contained in the report is current as of the date appearing on the report and is
        subject to change without notice, unless indicated otherwise by Quantstamp; however,
        Quantstamp does not guarantee or warrant the accuracy, timeliness, or completeness of any
        report you access using the internet or other means, and assumes no obligation to update any
        information following publication or other making available of the report to you by
        Quantstamp.
      </p>
    </div>
    <div>
      <h4>Notice of confidentiality</h4>
      <p>
        This report, including the content, data, and underlying methodologies, are subject to the
        confidentiality and feedback provisions in your agreement with Quantstamp. These materials
        are not to be disclosed, extracted, copied, or distributed except to the extent expressly
        authorized by Quantstamp.
      </p>
    </div>
    <div>
      <h4>Links to other websites</h4>
      <p>
        You may, through hypertext or other computer links, gain access to web sites operated by
        persons other than Quantstamp. Such hyperlinks are provided for your reference and
        convenience only, and are the exclusive responsibility of such web sites&apos; owners. You
        agree that Quantstamp are not responsible for the content or operation of such web sites,
        and that Quantstamp shall have no liability to you or any other person or entity for the use
        of third-party web sites. Except as described below, a hyperlink from this web site to
        another web site does not imply or mean that Quantstamp endorses the content on that web
        site or the operator or operations of that site. You are solely responsible for determining
        the extent to which you may use any content at any other web sites to which you link from
        the report. Quantstamp assumes no responsibility for the use of third-party software on any
        website and shall have no liability whatsoever to any person or entity for the accuracy or
        completeness of any output generated by such software.
      </p>
    </div>
    <div>
      <h4>Disclaimer</h4>
      <p>
        The review and this report are provided on an as-is, where-is, and as-available basis. To
        the fullest extent permitted by law, Quantstamp disclaims all warranties, expressed implied,
        in connection with this report, its content, and the related services and products and your
        use thereof, including, without limitation, the implied warranties of merchantability,
        fitness for a particular purpose, and non-infringement. You agree that access and/or use of
        the report and other results of the review, including but not limited to any associated
        services, products, protocols, platforms, content, and materials, will be at your sole risk.
        FOR AVOIDANCE OF DOUBT, THE REPORT, ITS CONTENT, ACCESS, AND/OR USAGE THEREOF, INCLUDING ANY
        ASSOCIATED SERVICES OR MATERIALS, SHALL NOT BE CONSIDERED OR RELIED UPON AS ANY FORM OF
        FINANCIAL, INVESTMENT, TAX, LEGAL, REGULATORY, OR OTHER ADVICE. This report is based on the
        scope of materials and documentation provided for a limited review at the time provided. You
        acknowledge that Blockchain technology remains under development and is subject to unknown
        risks and flaws and, as such, the report may not be complete or inclusive of all
        vulnerabilities. The review is limited to the materials identified in the report and does
        not extend to the compiler layer, or any other areas beyond the programming language, or
        programming aspects that could present security risks. The report does not indicate the
        endorsement by Quantstamp of any particular project or team, nor guarantee its security, and
        may not be represented as such. No third party is entitled to rely on the report in any way,
        including for the purpose of making any decisions to buy or sell a product, service or any
        other asset. Quantstamp does not warrant, endorse, guarantee, or assume responsibility for
        any product or service advertised or offered by a third party, or any open source or
        third-party software, code, libraries, materials, or information to, called by, referenced
        by or accessible through the report, its content, or any related services and products, any
        hyperlinked websites, or any other websites or mobile applications, and we will not be a
        party to or in any way be responsible for monitoring any transaction between you and any
        third party. As with the purchase or use of a product or service through any medium or in
        any environment, you should use your best judgment and exercise caution where appropriate.
      </p>
    </div>
  </Section>
)

export default AboutQuantstamp
